import { normalizeCountryCodeValue } from '../stores/app'

export const COUNTRY_CODE_COOKIE_NAME = 'CountryCode'
export const MY_COUNTRY_COOKIE_NAME = 'CURRIPCOUNTRY'
export const DEFAULT_COUNTRY_CODE = '840'

export const normalizeCountryCookieValue = (value: unknown) => {
  return normalizeCountryCodeValue(value)
}

export const resolveCountryCodeFromCookieValue = (value: unknown) => {
  return normalizeCountryCookieValue(value) || DEFAULT_COUNTRY_CODE
}
